// extracted by mini-css-extract-plugin
export default {"header-img":"aOfb5","icon":"dsBVu"};